module.exports = __webpack_public_path__ + "static/media/mech.e3780bdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mech.png
// module id = 5823
// module chunks = 0